'use client'

import {
  EASE,
  SectionHead,
  restoreDashes,
  useReveal,
} from '@/components/page-kit'
import { PAYROLL } from './data'

/* The four authored benefits, as a 2×2 of quiet text blocks separated by
   hairlines — no icon in a tinted rounded square.

   Heading is a verbatim fragment of `description`, capitalised to open a
   sentence. */

export function PayrollBenefits() {
  const grid = useReveal<HTMLDivElement>(0.12)

  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <SectionHead
          eyebrow="Why Payroll"
          title="Integrated with HR and attendance to eliminate duplication."
        />

        <div ref={grid.ref} className="mt-10 sm:mt-12">
          <div className="grid grid-cols-1 gap-px bg-border/70 sm:grid-cols-2">
            {PAYROLL.benefits.map((b, i) => (
              <div
                key={b.title}
                className="bg-background px-0 py-7 sm:px-7 sm:py-9"
                style={{
                  opacity: grid.shown ? 1 : 0,
                  transform: grid.shown ? 'none' : 'translateY(10px)',
                  transition: `opacity 500ms ${EASE} ${i * 90}ms, transform 500ms ${EASE} ${i * 90}ms`,
                }}
              >
                <div className="flex items-baseline gap-3">
                  <span className="text-[11px] font-semibold tabular-nums text-muted-foreground/60">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <h3 className="font-heading text-lg font-normal leading-snug text-foreground sm:text-xl">
                    {b.title}
                  </h3>
                </div>
                <p className="mt-3 max-w-md pl-[26px] text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {restoreDashes(b.description)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
